<template>
    <div>
        <!-- <div
            :class="{
                'collapse-btn': collapse,
                'collapse-btn-small': !collapse
            }"
            @click="collapseChage"
        >
            <i v-if="!collapse" class="el-icon-caret-left"></i>
            <i v-else class="el-icon-caret-right"></i>
        </div> -->

        <div class="header">
            <div class="logoDataImg" v-text="title"></div>
            <!-- 折叠按钮 -->

            <!-- <div class="logo" v-text="title"></div> -->
            <div class="header-right">
                <div class="header-user-con">
                    <!-- 换肤 -->
                    <div class="theme"></div>
                    <!-- 用户头像 -->
                    <div class="user-avator">
                        <img src="../../assets/img/bg.jpg" />
                    </div>
                    <!-- 用户名下拉菜单 -->
                    <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                        <span class="el-dropdown-link">
                            {{ username }}
                            <i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item command="personalCenter">个人中心</el-dropdown-item> -->
                            <el-dropdown-item command="setPassword">修改密码</el-dropdown-item>
                            <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <!-- 修改密码的dialog -->
            <el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
                <el-form :model="pwdForm" :rules="rules" ref="pwdForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="旧密码" prop="oldPwd">
                        <el-input :type="pwdType1" v-model="pwdForm.oldPwd" placeholder="请输入旧密码">
                            <i slot="suffix" class="el-input__icon el-icon-view" :class="{ pwd: isPwd1 }" @click="handleToPwd1"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="newPwd">
                        <el-input :type="pwdType2" v-model="pwdForm.newPwd" placeholder="请输入新密码">
                            <i slot="suffix" class="el-input__icon el-icon-view" :class="{ pwd: isPwd2 }" @click="handleToPwd2"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码" prop="confirmNewPwd">
                        <el-input :type="pwdType3" v-model="pwdForm.confirmNewPwd" placeholder="请再次输入新密码">
                            <i slot="suffix" class="el-input__icon el-icon-view" :class="{ pwd: isPwd3 }" @click="handleToPwd3"></i>
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button type="text" @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="changePwd">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import bus from '../common/bus';
import Bus from '../../components/common/bus.js';
const version = require('element-ui/package.json').version; // element-ui version from node_modules
export default {
    data() {
        var checkPwd = (rule, value, callback) => {
            let data = {};
            data.oldPassword = this.pwdForm.oldPwd;
            this.$axios.post('sys/user/oldPasswordIsRight', data).then(res => {
                if (res.data.code != 0) {
                    callback(new Error(res.data.data));
                    this.pwdForm.oldPwd = '';
                } else {
                    callback();
                }
            });
        };
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.pwdForm.newPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            collapse: false,
            // 头像
            // 头部标题
            title: '后台管理系统',
            // 当前登录用户id
            // userId: sessionStorage.getItem('userId'),
            // 控制修改密码对话框的显示与隐藏
            dialogVisible: false,
            // 修改密码的表单
            pwdForm: {
                // 旧密码
                oldPwd: '',
                // 新密码
                newPwd: '',
                // 确认新密码
                confirmNewPwd: ''
            },
            // 修改密码的验证规则
            rules: {
                oldPwd: [
                    { required: true, message: '请输入旧密码', trigger: 'blur' },
                    { validator: checkPwd, message: '旧密码错误', trigger: 'blur' },
                    { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
                ],
                newPwd: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
                ],
                confirmNewPwd: [
                    { required: true, trigger: 'blur', validator: validatePass },
                    { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
                ]
            },
            // 控制颜色选择器的显示与隐藏
            chalk: '', // 当前是否已经获取过css样式文件内容，如果获取过，这里会有值，避免多次获取
            showColorPicker: true,
            color: '#409EFF',
            predefineColors: ['#409EFF', '#1890ff', '#304156', '#212121', '#11a983', '#13c2c2', '#6959CD', '#f5222d'],
            // 修改密码文本框的type
            pwdType1: 'password',
            isPwd1: false,
            pwdType2: 'password',
            isPwd2: false,
            pwdType3: 'password',
            isPwd3: false
        };
    },
    computed: {
        username() {
            let username = sessionStorage.getItem('userName');
            return username ? username : this.name;
        }
    },
    created() {
        Bus.$on('getTarget', target => {
            this.getUserInfo();
        });
        this.getUserInfo();
    },
    methods: {
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                // localStorage.removeItem('ms_username');
                sessionStorage.clear();
                this.$router.push('/login');
            } else if (command == 'personalCenter') {
                // this.$notify({
                //     title: '信息',
                //     message: '开发中...',
                //     type: 'info'
                // });
                this.$router.push('/personalInfo');
            } else if (command == 'setPassword') {
                this.dialogVisible = true;
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 修改密码
        changePwd() {
            this.$refs.pwdForm.validate(async valid => {
                if (valid) {
                    const res = await this.$axios.post('sys/user/changePwd', {
                        password: this.pwdForm.newPwd
                    });
                    if (res.data.code == 0) {
                        this.$message.success(`${res.data.data}`);
                        this.isPwd1 = false;
                        this.pwdType1 = 'password';
                        this.isPwd2 = false;
                        this.pwdType2 = 'password';
                        this.isPwd3 = false;
                        this.pwdType3 = 'password';
                        this.handleClose();
                        sessionStorage.clear();
                        this.$router.push('/login');
                    } else {
                        this.$message.error(`${res.data.data}`);
                        this.handleClose();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // dialog关闭事件
        handleClose() {
            this.dialogVisible = false;
            this.isPwd1 = false;
            this.pwdType1 = 'password';
            this.isPwd2 = false;
            this.pwdType2 = 'password';
            this.isPwd3 = false;
            this.pwdType3 = 'password';
            this.$refs.pwdForm.resetFields();
        },
        // 显示隐藏密码
        handleToPwd1() {
            this.isPwd1 = !this.isPwd1;
            if (this.isPwd1) {
                this.pwdType1 = 'text';
            } else {
                this.pwdType1 = 'password';
            }
        },
        handleToPwd2() {
            this.isPwd2 = !this.isPwd2;
            if (this.isPwd2) {
                this.pwdType2 = 'text';
            } else {
                this.pwdType2 = 'password';
            }
        },
        handleToPwd3() {
            this.isPwd3 = !this.isPwd3;
            if (this.isPwd3) {
                this.pwdType3 = 'text';
            } else {
                this.pwdType3 = 'password';
            }
        },
        async getUserInfo() {
            // const res = await this.$axios.post('/sys/user/getUserInfoSelf', {});
            // if (res.data.code == 0) {
            //     this.headImg = res.data.data.headImg;
            // }
        }
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
    background-size: cover;
    background-color: #001529;
}

.collapse {
    background: rgb(25, 32, 45) !important;
    color: #fff !important;
}

.collapse-btn {
    position: absolute;
    height: 50px;
    line-height: 50px;
    background: #fff;
    width: 18px;
    top: 120px;
    left: 64px;
    cursor: pointer;
    z-index: 2000;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid #dcdfe6;
    border-left: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    transition: 0.3s left ease-in-out;
}

.collapse-btn-small {
    position: absolute;
    height: 50px;
    line-height: 50px;
    background: #fff;
    width: 18px;
    text-align: center;
    top: 120px;

    left: 200px;
    cursor: pointer;
    z-index: 2000;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid #dcdfe6;
    border-left: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    transition: 0.3s left ease-in-out;
}

.logoDataImg {
    float: left;
    /* width: 250px; */
    width: 200px;
    line-height: 70px;
    /* text-indent: 2.5em; */
    /* background: url('../../assets/logo.png') no-repeat left; */
    background-size: 40px 40px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    height: 70px;
}
.header-right {
    float: right;
    padding-right: 50px;
}

.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}

.btn-fullscreen {
    /* transform: rotate(45deg); */
    margin-right: 5px;
    font-size: 24px;
}

.user-name {
    margin-left: 10px;
}

.user-avator {
    margin-left: 20px;
}

.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}

.el-dropdown-menu__item {
    text-align: center;
}

.el-icon-s-open {
    font-size: 24px;
    color: #fff;
}

.el-icon-s-promotion {
    font-size: 24px;
    color: #fff;
    margin-right: 8px;
}

.dialog-footer {
    text-align: right;
}

.el-icon-view {
    cursor: pointer;
}

.el-icon-view {
    cursor: pointer;
}

.pwd {
    color: #409eff;
}
</style>
